import { defineMessages } from 'react-intl';

export type BlogSport = 'football' | 'nba' | 'mlb';

export const supportedLanguages = new Set(['fr', 'it', 'de', 'es', 'en']);

export const categories = defineMessages({
  news: {
    defaultMessage: 'News',
  },
  'fantasy-meets-reality': {
    defaultMessage: 'Fantasy Meets Reality',
  },
  'get-started': {
    defaultMessage: 'Get Started',
  },
});

export const DEFAULT_POST_PICTURE =
  'https://frontend-assets.sorare.com/meta/social-picture-2022.png';
